module.exports = __webpack_public_path__ + "static/media/trafficOn.2b0d1717.png";